
































import { HTTP_RESPONSE } from "@/services/Enums";
import { General } from "@/services/General";
import axios from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ForgotPassword extends Vue {
    username: string = null;
    loading: boolean = false;
    isSaveClicked: boolean = false;

    mounted() {
    }

    getMessage(data: any) {        
        switch (data.response) {
            case HTTP_RESPONSE.LoginFailed:
                let msg = 'Login failed';
                if (data.message != null && data.message != "") msg = msg + " - " + data.message;
                return msg;
            case HTTP_RESPONSE.UserDoesntExist:
                return 'User doesn\'t exist';
            case HTTP_RESPONSE.UserLockedOut:
                return 'User is now blocked, too many incorrect attempts. Use "Forgot Password" link to reset your password.';
            case HTTP_RESPONSE.InternalUser:
                return 'Inserted Username / e-mail match a PLI domain account. If you forgot your PLI credentials, please use portal <a href="https://mypassword.pli-petronas.com/" target="mypassword">mypassword.pli-petronas.com</a>.';
        }
        return 'Error code: ' + data.response;
    }

    async resetPasswordRequest() {
        this.isSaveClicked = true;
        if(this.isValidForm()) {             
            try {
                this.loading = true;
                let response:any = await axios({
                    method: 'post',
                    url: General.GetApiUrl('/api/auth/ResetPasswordRequest?username=' + this.username + '&forgotPassword=true'),
                    withCredentials: true,
                    responseType: 'json'
                });

                if (response.data.response == HTTP_RESPONSE.OK) {
                    this.$emit('onForgotPasswordRequestSuccess');
                    General.showAlertSuccess('Reset Password request was sent correctly: please check your e-mail', this);
                } else {
                    this.$fire({
                        html: this.getMessage(response.data),
                        type: "error"
                    });
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                General.showAlertDanger(error, this);
            }
        }
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    isValidForm() {
        let isValid: boolean = true;
        if(this.CheckIsNullOrEmpty(this.username)) {
            isValid = false;
        }
        return isValid
    }
    
    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text.toString() === '') return true;
        return false;
    }
}
